import React, { useState, useEffect } from "react";
import "./index.scss";
import SearchIcon from "../../svgs/search.svg";
import AddCircleIcon from "../../svgs/add-circle.svg";
import RollOutList from "./components/RollOutList";
import RollOutModal from "./components/RollOutModal";
import useDebounce from "../../../Shared/GeographyFilters/hooks/useDebounce";
import UnbindingRequestBulkUploader from "./components/UnbindingRequestBulkUploader";

const RollOut = () => {
  const [showRollOutModal, setShowRollOutModal] = useState(false);
  const [showUnbindingRequestModal, setShowUnbindingRequestModal] =
    useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rolloutListKey, setRolloutListKey] = useState(0);
  const userType = JSON.parse(localStorage.getItem("currUserType"));

  const debouncedSearchTerm = useDebounce(localSearchTerm, 400);

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleRolloutCreated = () => {
    setRolloutListKey((prev) => prev + 1);
  };

  const handleUnbindingRequestCreated = () => {};

  return (
    <div className="content-section">
      <div className="content-header">
        <div></div>
        <div className="filters-section">
          <div className="search-input">
            <img src={SearchIcon} alt="Search Icon" className="search-icon" />
            <input
              type="text"
              id="rollout-search"
              value={localSearchTerm}
              onChange={(e) => setLocalSearchTerm(e.target.value)}
              placeholder="Search"
              className="search-input-field"
            />
          </div>
          {userType === "bkash-super-user" && (
            <button
              className="create-btn"
              onClick={() => setShowUnbindingRequestModal(true)}
            >
              <img src={AddCircleIcon} alt="Add Icon" className="btn-icon" />
              Approve Unbinding
            </button>
          )}
          {userType === "bkash-super-user" && (
            <button
              className="create-btn"
              onClick={() => setShowRollOutModal(true)}
            >
              <img src={AddCircleIcon} alt="Add Icon" className="btn-icon" />
              New Roll Out Mapping
            </button>
          )}
        </div>
      </div>
      <div className="content-body">
        <RollOutList key={rolloutListKey} searchTerm={searchTerm} />
      </div>
      {showUnbindingRequestModal && (
        <UnbindingRequestBulkUploader
          setShowUnbindingRequestModal={setShowUnbindingRequestModal}
          onUnbindingRequestCreated={handleUnbindingRequestCreated}
        />
      )}
      {showRollOutModal && (
        <RollOutModal
          showRollOutModal={showRollOutModal}
          setShowRollOutModal={setShowRollOutModal}
          onRolloutCreated={handleRolloutCreated}
        />
      )}
    </div>
  );
};

export default RollOut;
